export * from './ConfigTitle';
